import React from 'react';
import { Link } from 'react-router-dom';
import error_404 from '../../assets/images/element/error404-01.svg'

function PageNotFound() {
  return (
    <section class="pt-5">
	<div class="container">
		<div class="row">
			<div class="col-12 text-center">
				{/* <!-- Image --> */}
				<img src={error_404} class="h-200px h-md-400px mb-4" alt=""/>
				{/* <!-- Title --> */}
				<h1 class="display-1 text-danger mb-0">404</h1>
				{/* <!-- Subtitle --> */}
				<h2>للأسف هنالك خطأ ما!</h2>
				{/* <!-- info --> */}
				<p class="mb-4">الرابط المحدد غير موجود, أو قد يكون تم تحديث الرابط لصفحة أخرى</p>
				{/* <!-- Button --> */}
				<Link to='/' class="btn btn-primary mb-0">العودة للصفحة الرئيسة</Link>
			</div>
		</div>
	</div>
</section>
  )
}

export default PageNotFound